(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/configs/assets/javascripts/overrides/sport/tennis.js') >= 0) return;  svs.modules.push('/components/sportinfo/configs/assets/javascripts/overrides/sport/tennis.js');
"use strict";


const newEnetpulseWidgets = svs.core.detect.feature('ft-enetpulse-new');
const _svs$components$sport = svs.components.sportinfo.common,
  MatchState = _svs$components$sport.matchState.SportinfoMatchState,
  _svs$components$sport2 = _svs$components$sport.constants,
  SportinfoPathNames = _svs$components$sport2.SportinfoPathNames,
  EnetPulseViewType = _svs$components$sport2.EnetPulseViewType,
  SportradarWidgets = _svs$components$sport2.SportinfoSportradarWidgets,
  SvsViewType = _svs$components$sport2.SvsViewType;
const _svs$components$sport3 = svs.components.sportinfo.common.constants,
  ContentProvider = _svs$components$sport3.ContentProvider,
  EnetpulseWidgets = _svs$components$sport3.EnetpulseWidgets;
const ConfigBuilder = svs.components.sportinfo.configBuilder.ConfigBuilder;
const _ConfigBuilder$addTab = new ConfigBuilder().addTab(SportinfoPathNames.MatchInfo, tab => {
    tab.setAll([{
      type: SvsViewType.MatchInfo,
      provider: ContentProvider.Svs
    }]).prepend(MatchState.Ongoing, [{
      type: SportradarWidgets.LiveMatchTracker,
      provider: ContentProvider.SportRadar
    }]);
  }).addTab(SportinfoPathNames.Statistic, tab => {
    tab.set(MatchState.NotStarted, [{
      type: SportradarWidgets.HeadToHead,
      provider: ContentProvider.SportRadar,
      viewProps: {
        components: ['form', 'lastmatches']
      }
    }]);
  }).addTab(SportinfoPathNames.News, tab => {
    tab.setAll([{
      type: SvsViewType.News,
      provider: ContentProvider.Svs
    }]);
  }).build(),
  menuItems = _ConfigBuilder$addTab.menuItems,
  content = _ConfigBuilder$addTab.content;
const _ConfigBuilder$addTab2 = new ConfigBuilder().addTab(SportinfoPathNames.MatchInfo, tab => {
    tab.setAll([{
      type: SvsViewType.MatchInfo,
      provider: ContentProvider.Svs
    }]).prepend(MatchState.Ongoing, [{
      type: SportradarWidgets.LiveMatchTracker,
      provider: ContentProvider.SportRadar
    }]);
  }).addTab(SportinfoPathNames.Events, tab => {
    tab.setMany([MatchState.Ongoing, MatchState.Finished], [{
      type: EnetPulseViewType.MatchIncidents,
      provider: ContentProvider.Enetpulse,
      title: 'Matchhändelser',
      widgetId: EnetpulseWidgets.MatchIncidents,
      viewProps: {
        options: {
          lng: 'sv'
        }
      }
    }]);
  }).addTab(SportinfoPathNames.News, tab => {
    tab.setAll([{
      type: SvsViewType.News,
      provider: ContentProvider.Svs
    }]);
  }).setDefaultRoutes(SportinfoPathNames.Events, [MatchState.Ongoing, MatchState.Finished]).build(),
  enetpulseMenuItems = _ConfigBuilder$addTab2.menuItems,
  enetpulseContent = _ConfigBuilder$addTab2.content;
setGlobal('svs.components.sportinfo.configs.sportConfigs.sportTypeOverrides', {
  tennisConfig: newEnetpulseWidgets ? {
    menuItems: enetpulseMenuItems,
    content: enetpulseContent,
    config: 'tennis' 
  } : {
    menuItems,
    content,
    config: 'tennis' 
  }
});

 })(window);